import React, { useState } from "react";
import {
  List,
  SwipeableDrawer,
  IconButton,
  ListItem,
  Paper,
  Divider,
  Box
} from "@material-ui/core";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MenuIcon from "@material-ui/icons/Menu";
import moment from 'moment';
import EmergencyNumberBar from "../EmergencyNumberBar";
import { PUBLICURL } from "../../main_config";
import menuItems from "../../data/menu_links";
import LinkEcco from "../Link";
import CloseIcon from "@material-ui/icons/Close";
import AccountCircle from "@material-ui/icons/AccountCircle";
import style from "./styles";
import { useStyles } from "../../hooks";
import { Facebook, LinkedIn, Instagram } from "../Icons";
import DialogModalGenerico from "../Modal/DialogModalGenerico";

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    padding: "0 10px"
  }
})(MuiExpansionPanelDetails);

const HeaderDrawer = () => {
  const styles = useStyles(style);
  const [managment, setManagment] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false
  });
  const [expanded, setExpanded] = useState("panel1");
  const [open, setOpen] = useState(false);
  const showModal = moment().isBetween(
    moment("2025-06-02T00:00:00"),
    moment("2025-06-21T23:59:59")
  );
  const isMaintenance = moment().isBetween(
    moment("2025-06-19T23:59:59"),
    moment("2025-06-21T23:59:59")
  );

  const toggle = (side, open) => event => {
    if (event &&
      event.type === "keydown" &&
      (event.key === "Shift" || event.key === "Tab")
    ) {
      return;
    }

    setManagment({ ...managment, [side]: open });
  };

  const handlePanelExpansion = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const sideBarMenu = side => (
    <div className={styles.list} role="presentation">
      <List>
        <Paper className={styles.paper}>
          <Typography style={{ fontWeight: "bold", fontSize: 18, marginLeft: "-7px" }}>
            MENU
            <IconButton
              onClick={toggle("right", false)}
              className={styles.button}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
        </Paper>
        {menuItems.map(item =>
          item.static ? (
            <ExpansionPanel
              key={`ep${item.key}`}
              square
              expanded={expanded === item.key}
              onChange={handlePanelExpansion(item.key)}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id={item.key}
              >
                <Typography className={styles.title}>
                  {item.label.toUpperCase()}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <List className={styles.expansionList}>
                  {item.elemens.map(child => (
                    <div key={`div-item-${child.key}`}>
                      <ListItem
                        key={`item-${child.key}`}
                        onClick={toggle("right", false)}
                      >
                        <LinkEcco to={`/${child.key}`} className={styles.link}>
                          {child.label}
                        </LinkEcco>
                      </ListItem>
                      {!child.last && <Divider className={styles.divider} />}
                    </div>
                  ))}
                </List>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ) : (
            <Paper key={`p${item.key}`} className={styles.itemPaper}>
              <Typography onClick={toggle("right", false)}>
                <LinkEcco to={`/${item.key}`} className={styles.title2}>
                  {item.label.toUpperCase()}
                </LinkEcco>
              </Typography>
            </Paper>
          )
        )}
        <Box className={styles.crossIcon} >
          <Typography variant="h6" className={styles.textRedes}>
            ¡Seguinos!
          </Typography>
          <LinkEcco
            external={true}
            url="https://www.facebook.com/eccoemergencias"
            href="https://www.facebook.com/eccoemergencias"
            target="_blank"
            style={{ cursor: 'pointer', color: "#797979" }}
          >
            <Facebook style={{ marginRight: 16, fontSize: "30px", }} />
          </LinkEcco>
          <LinkEcco
            external={true}
            url="https://www.instagram.com/eccoemergencias"
            href="https://www.instagram.com/eccoemergencias"
            target="_blank"
            style={{ cursor: 'pointer', color: "#797979" }}
          >
            <Instagram style={{ marginRight: 16, fontSize: "30px", }} />
          </LinkEcco>
          <LinkEcco
            external={true}
            url="https://www.linkedin.com/company/eccoemergencias"
            href="https://www.linkedin.com/company/eccoemergencias"
            target="_blank"
            style={{ cursor: 'pointer', color: "#797979" }}
          >
            <LinkedIn style={{ marginRight: 6, fontSize: "30px", }} />
          </LinkEcco>
        </Box>
      </List>
    </div>
  );

  const renderModal = () => {
    return (
      <DialogModalGenerico
        open={open}
        handleClose={handleClose}
        title="Mantenimiento"
      />
    );
  }

  const handleIngresarClick = e => {
    e.preventDefault();
    showModal ? setOpen(true) : window.open(`${PUBLICURL}/login#/`,'_self');
  }

  const handleClose = () => {
    setOpen(false);
    !isMaintenance && window.open(`${PUBLICURL}/login#/`,'_self');
  }

  return (
    <>
      <Box
        className={styles.root}
      >
        <EmergencyNumberBar />
        <Box
          display="flex"
          alignItems="center"
        >
        <LinkEcco to="/" className={styles.eccoLogo}>
          <img
            src={`${PUBLICURL}/assets/images/ecco_color.png`}
            alt="Ecco"
            className={styles.logo}
          />
        </LinkEcco>
        </Box>
        <Box style={{ position: "relative" }}>
          <IconButton style={{ position: "absolute", right: 50, top: 20 }}>
            <LinkEcco style={{ color: "#4D4F5C" }} onClick={handleIngresarClick}>
              <AccountCircle />
            </LinkEcco>
          </IconButton>
          <IconButton
            onClick={toggle("right", true)}
            style={{ position: "absolute", right: 5, top: 20 }}
          >
            <MenuIcon />
          </IconButton>
          <SwipeableDrawer
            open={managment.right}
            anchor="right"
            onClose={toggle("right", false)}
            onOpen={toggle("right", true)}
          >
            {sideBarMenu("right")}
          </SwipeableDrawer>
        </Box>
      </Box>
      { showModal && renderModal() }
    </>

  );
};

export default HeaderDrawer;
